import { useEffect, useRef, useState } from "react";

/**
 * Largura do contêiner em px, acompanhando redimensionamento. Sem ResizeObserver (jsdom) ou
 * antes da primeira medida, vale `fallback`.
 */
export function useContainerWidth(fallback = 360) {
    const ref = useRef(null);
    const [width, setWidth] = useState(fallback);
    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const measure = () => { if (el.clientWidth > 0) setWidth(el.clientWidth); };
        measure();
        if (typeof window === "undefined" || !window.ResizeObserver) return undefined;
        const observer = new window.ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    return [ref, width];
}
